export default __webpack_public_path__ + "static/media/single-project-page-01-img14.142a5278.png";